import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';
import type { AvailabilityData } from '../components/GanttChart';

interface AvailabilityResponse {
  data: AvailabilityData;
}

export function useScheduleAvailability(startDate: string, endDate: string) {
  return useQuery({
    queryKey: ['schedule-availability', startDate, endDate],
    queryFn: async (): Promise<AvailabilityResponse> => {
      const params = new URLSearchParams({ startDate, endDate });
      return apiFetch<AvailabilityResponse>(`/api/v1/schedule/availability?${params}`);
    },
    enabled: !!startDate && !!endDate,
    staleTime: 60000, // 1 minute - availability changes less frequently than schedule
  });
}
